"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhonenumberPipe = void 0;
class PhonenumberPipe {
    transform(value) {
        if (value != null) {
            this.homeNpa = value.substring(0, 3);
            this.homeNxx = value.substring(3, 6);
            this.homeXxxx = value.substring(6, 10);
            this.formaattedNumber = this.homeNpa + '-' + this.homeNxx + '-' + this.homeXxxx;
            return this.formaattedNumber;
        }
    }
}
exports.PhonenumberPipe = PhonenumberPipe;
//# sourceMappingURL=phoneNumber.pipe.js.map